import { combineReducers } from "redux";
import { notification } from "./notificationReducer";

const notificationReducer = combineReducers({
  notification,
});

export default notificationReducer;
